import type { AccountCampaignBulkAction } from '../../types/accountCampaign';

// Friendly past-tense label for the bulk-result toast ("12 rows marked Built").
// Centralised so RolloutDetail (master grid) and the Meta / Google grids
// agree on phrasing — and the exhaustiveness check fires once when a new
// bulk-action kind lands.

export function bulkActionLabel(action: AccountCampaignBulkAction): string {
  switch (action.kind) {
    case 'setMetaReady':
      return action.value ? 'marked Meta Ready' : 'cleared Meta Ready';
    case 'setGoogleReady':
      return action.value ? 'marked Google Ready' : 'cleared Google Ready';
    case 'assignAm':
      return 'assigned AM';
    case 'assignCampaign':
      return 'assigned Campaign';
    case 'setStartDate':
      return 'start date updated';
    case 'setEndDate':
      return 'end date updated';
    case 'setMetaBuilt':
      return action.value ? 'marked Meta Main Built' : 'cleared Meta Main Built';
    case 'setMetaTurnedOn':
      // Round-3 polish Fix 3: display flip — wire kind stays
      // setMetaTurnedOn.
      return action.value ? 'marked Meta Scheduled/Live' : 'cleared Meta Scheduled/Live';
    case 'setMetaPostRolloutCheck':
      return action.value ? 'marked Meta Post-Check' : 'cleared Meta Post-Check';
    case 'setGoogleBuilt':
      return action.value ? 'marked Google Main Built' : 'cleared Google Main Built';
    case 'setGoogleScheduled':
      return action.value ? 'marked Google Scheduled' : 'cleared Google Scheduled';
    case 'setGooglePostRolloutCheck':
      // Round-3 polish Fix 3: display flip — wire kind stays
      // setGooglePostRolloutCheck.
      return action.value ? 'marked Google Budget Updated' : 'cleared Google Budget Updated';
    // Round-1 polish Fix 6: bulk-assign builder labels. We don't have
    // the user's display name in scope here — the toast just says
    // "assigned" / "unassigned" and the audit log's per-row entry
    // captures the uid for forensics.
    case 'setMetaBuilder':
      return action.builderId === null ? 'unassigned Meta builder' : 'assigned Meta builder';
    case 'setGoogleBuilder':
      return action.builderId === null
        ? 'unassigned Google builder'
        : 'assigned Google builder';
    // Multi Lead Form spec §4. Bulk-assign a lead form across selected
    // rows. Cross-Campaign protection lives upstream (client gate +
    // service-side reject); this label is the toast-side summary.
    case 'assignLeadForm':
      return 'assigned Lead Form';
  }
}
